import { withStyles, makeStyles } from '@material-ui/core/styles';
import { TablePagination, TableCell, Chip } from "@material-ui/core";

const StyledTablePagination = withStyles(() => ({
   root: {
     fontSize: '14px',
   },
   caption: {
     fontSize: '14px',
   },
   actions: {
     Button: {
       fontSize: '14px',
     },
   },
 }))(TablePagination);

 const StyledTableCell = withStyles(() => ({
   root: {
     border: 'none',
     padding: 6,
     fontSize: '1rem',
     whiteSpace: 'nowrap'
   },
 }))(TableCell);

 const StyledActiveChip = withStyles(() => ({
  label: {
    color: 'white',
  },
  root: {
    backgroundColor: '#5AA600',
    height: 25,
    '& :active': {
      backgroundColor: '#5AA600',
    },
  },
}))(Chip);

const StyledLightActiveChip = withStyles(() => ({
  label: {
    color: 'white',
  },
  root: {
    backgroundColor: '#ACE65D',
    height: 25,
    '& :active': {
      backgroundColor: '#5AA600',
    },
  },
}))(Chip);

const StyledInactiveChip = withStyles(() => ({
  root: {
    height: 25,
  },
}))(Chip);

const useStyles = makeStyles((theme) => ({
  card: {
    padding: '10px 0',
    background: 'white',
    borderRadius: '16px',
    margin: '10px 0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  chart_card: {
    padding: 15,
    margin: '10px 0',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down('sm')]: {
      padding: 5,
      marginBottom: 15,
    },
  },
  wrapper: {
    margin: '10px 20px',
    overflowX: 'auto',
    '&>*': {
      overflowX: 'auto',
    },
  },
  card__wrapper: {
    padding: '0 10px',
  },
  heading: {
    padding: '0 0 10px 16px',
    fontSize: 20,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      padding: '0 0 5px 5px',
    },
  },
  chart_heading: {
    fontSize: 20,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      padding: '0 0 5px 5px',
    },
  },
  metric_value: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 45,
    fontWeight: 600
  },
  card_title: {
    color: '#58595B',
    fontSize: 25,
    fontWeight: 700,
    margin: "5px 0 20px 15px"
  },
  tableFiltersFlex: {
    '& .MuiInputLabel-formControl': {
      padding: '0',
      top: '-10px',
    },
    '& .MuiOutlinedInput-root': {
      height: '35px',
    }
  },
  searchInput: {
    minWidth: 200,
    marginLeft: 10,
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      marginLeft: 0,
      paddingLeft: '5%',
      '& .MuiChip-root': {
        textAlign: 'center',
      },
    },
  },
  chipMargin: {
    margin: '0 5px',
  },
  banner_wrapper: {
    margin: 20,
    overflow: 'visible',
  },
  center: {
    textAlign: 'center',
    maxWidth: '100%',
  },
  paragraph: {
    fontFamily: 'Roboto Condensed',
    fontSize: 18,
    lineHeight: '25.5px',
    letterSpacing: '1%',
    color: '#4D4D4F',
    fontWeight: 300,
  },
  headingTitle: {
    fontSize: 45,
    color: '#00B5E2',
    margin: 0,
    marginTop: 15,
    fontFamily: 'Playfair Display',
  },
  bigText: {
    fontSize: 34,
    color: '#00B5E2',
    fontWeight: 700,
    fontFamily: 'Roboto',
  },
  topLogo: {
    textAlign: 'center',
    height: 75,
    width: 75,
    marginTop: -37.5,
  },
  linkListPopup: {
    '& .MuiDialog-paperWidthSm': {
      minWidth: '82%',
    },
    '& .MuiDialogTitle-root': {
      padding: "7px 24px 0",
      '& .MuiTypography-root': {
        fontWeight: 600,
        fontSize: 17,
        textAlign: 'center',
      },
    },
  },
}))

 export {
   useStyles,
   StyledTableCell,
   StyledTablePagination,
   StyledActiveChip,
   StyledLightActiveChip,
   StyledInactiveChip,
 };